export default __webpack_public_path__ + "static/ramanSharma-e7b74ef5fd6abbded8b6ff9672c85cfb.jpg";